'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { isEqual } from 'underscore';
import styled from 'styled-components';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PREVIEW_IFRAME_NAME = 'hs-preview-iframe';
export const PREVIEW_IFRAME_FORM_NAME = 'hs-preview-iframe-form';
const PreviewFrame = styled.div.withConfig({
  displayName: "EPPreviewIframe__PreviewFrame",
  componentId: "y07h6c-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:100%;iframe{border:none;width:100%;height:100%;}"]);
const SpinnerContainer = styled.div.withConfig({
  displayName: "EPPreviewIframe__SpinnerContainer",
  componentId: "y07h6c-1"
})(["position:absolute;top:calc(50% - 14px);z-index:-1;"]);
class EPPreviewIframe extends Component {
  constructor(props) {
    super(props);
    this.onLoad = this.onLoad.bind(this);
    this.state = {
      isLoading: true
    };
  }
  componentDidMount() {
    const {
      formUrl
    } = this.props;
    if (formUrl) {
      this.submitForm();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      formData,
      formUrl
    } = this.props;
    if (formUrl) {
      if (prevProps.formUrl !== formUrl || !isEqual(prevProps.formData, formData)) {
        this.submitForm();
      }
    } else if (prevProps.formUrl) {
      // Force refresh the iframe when formUrl is removed
      // eslint-disable-next-line no-self-assign
      this.iframeRef.src = this.iframeRef.src;
    }
  }
  submitForm() {
    if (this.formRef) {
      this.formRef.submit();
    }
  }
  onLoad() {
    this.setState({
      isLoading: false
    });
  }
  renderFormInputs() {
    const {
      formData
    } = this.props;
    return Object.keys(formData).map((key, i) => {
      if (typeof formData[key] === 'undefined') return null;
      return /*#__PURE__*/_jsx("input", {
        type: "hidden",
        name: key,
        value: JSON.stringify(formData[key])
      }, i);
    });
  }
  renderForm() {
    const {
      formUrl
    } = this.props;
    if (!formUrl) return null;
    return /*#__PURE__*/_jsx("form", {
      ref: ref => this.formRef = ref,
      className: "hidden",
      action: formUrl,
      target: PREVIEW_IFRAME_NAME,
      "data-test-id": PREVIEW_IFRAME_FORM_NAME,
      method: "post",
      children: this.renderFormInputs()
    });
  }
  render() {
    const {
      previewUrl,
      deviceHeader
    } = this.props;
    const {
      isLoading
    } = this.state;
    return /*#__PURE__*/_jsxs(PreviewFrame, {
      children: [isLoading && /*#__PURE__*/_jsx(SpinnerContainer, {
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {})
      }), deviceHeader, this.renderForm(), /*#__PURE__*/_jsx("iframe", {
        ref: ref => this.iframeRef = ref,
        src: previewUrl,
        onLoad: this.onLoad,
        name: PREVIEW_IFRAME_NAME,
        "data-test-id": PREVIEW_IFRAME_NAME,
        allow: "clipboard-write",
        sandbox: "allow-scripts allow-forms allow-popups allow-modals allow-same-origin allow-popups-to-escape-sandbox"
      })]
    });
  }
}
EPPreviewIframe.propTypes = {
  deviceHeader: PropTypes.node,
  formData: PropTypes.object,
  formUrl: PropTypes.string,
  previewUrl: PropTypes.string.isRequired
};
EPPreviewIframe.defaultProps = {
  formData: {}
};
export default EPPreviewIframe;